import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Zoom = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.666 30.265a17.92 17.92 0 0 0 4.418-11.807C36.084 8.516 27.99.42 18.05.42S0 8.516 0 18.458c0 9.943 8.093 18.039 18.033 18.039 4.383 0 8.525-1.571 11.804-4.42L41.795 44.04c.26.26.587.38.915.38.328 0 .656-.12.915-.38.5-.5.5-1.329 0-1.83l-11.96-11.945ZM2.588 18.458c0-8.527 6.938-15.449 15.445-15.449 8.508 0 15.445 6.94 15.445 15.45 0 4.125-1.605 8.009-4.521 10.926a15.348 15.348 0 0 1-10.924 4.523c-8.507.017-15.445-6.922-15.445-15.45Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.469 12.796h-4.124V8.671c0-.708-.587-1.295-1.295-1.295-.707 0-1.294.587-1.294 1.295v4.126h-4.124c-.708 0-1.294.586-1.294 1.294 0 .708.586 1.295 1.294 1.295h4.124v4.125c0 .708.587 1.295 1.294 1.295.708 0 1.295-.587 1.295-1.295v-4.125h4.124c.707 0 1.294-.587 1.294-1.295s-.587-1.294-1.294-1.294ZM23.469 24.655H12.632c-.708 0-1.294.587-1.294 1.295s.586 1.295 1.294 1.295h10.837c.707 0 1.294-.587 1.294-1.295s-.587-1.295-1.294-1.295Z"
  })));
});
Zoom.displayName = 'Zoom';
Zoom.defaultProps = {
  'aria-label': 'Zoom'
};
export default Zoom;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Zoom.js
// module id = 3334
// module chunks = 11